import React, { useState } from "react";
import { Button } from ".";
import { Modal } from "../elements";
import { Flex } from "../layouts";

interface ConfirmProps {
  open?: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  action?: string;
  type?: "success" | "info" | "danger" | "warning";
  onConfirm: (setOpen: React.Dispatch<React.SetStateAction<boolean>>) => void;
  loading?: boolean;
  setLoading?: React.Dispatch<React.SetStateAction<boolean>>;
  item?: React.ReactNode;
  title?: string;
  form?: string;
}
export const Confirm: React.FC<ConfirmProps> = ({
  open,
  setOpen,
  action = "delete",
  type = "danger",
  form = "",
  onConfirm,
  item,
  title = "Delete Item",
  loading,
}) => {
  return (
    <Modal open={open} closeButton={false}>
      <div className="font-bold text-xl text-gray-700">{title}</div>
      <div className="text-sm text-gray-400">
        Are you sure you want to {action} this item?
      </div>
      {item}
      <Flex className="space-x-2 justify-end w-full">
        <Button
          normal
          shadow={false}
          className="text-sm"
          form={form}
          variant={type as any}
          loading={loading}
          onClick={async () => {
            await onConfirm(setOpen);
          }}
        >
          <div>Confirm</div>
        </Button>
        <Button
          normal
          className="text-sm"
          shadow={false}
          variant="lightGray"
          onClick={() => setOpen(false)}
        >
          Cancel
        </Button>
      </Flex>
    </Modal>
  );
};
